<script setup lang="ts">
import {Popover, PopoverContent, PopoverTrigger} from "@/core/components/ui/popover";
import {CheckCheck} from "@lucide/vue";
import StorageService from "@/core/services/StorageService";
import {VitaleReaderCheck} from "@/core/interfaces/detection/detection";
import {onMounted, ref} from "vue";

const apilec = ref<VitaleReaderCheck>();

onMounted(async () => {
    try {
        const check = await window.ipcRenderer.invoke('detection:check-reader') as VitaleReaderCheck | {error: string} | null;

        if (check && typeof check.error !== 'string') {
            apilec.value = check as VitaleReaderCheck;

            return;
        }
    } catch {
        // Older Electron versions do not expose the on-demand check.
    }

    // Fall back to the result persisted by a previous check.
    apilec.value = await StorageService().read('apilec') as unknown as VitaleReaderCheck | undefined;
});

const AccessModes = {
    0: 'Indéfini',
    1: 'PC/SC',
    2: 'GALSS + PC/SC',
    3: 'GALSS TL',
    4: 'GALSS RAC'
};

</script>

<template>
  <div>
    <Popover>
      <PopoverTrigger class="flex items-center gap-2 text-sm">
        <CheckCheck :size="18" class="text-green" />
        <div class="text-gray-500">
          Auto-test OK.
        </div>
      </PopoverTrigger>
      <PopoverContent class="bg-primary ml-4">
        <div v-if="apilec" class="flex flex-col text-sm">
          <div class="text-gray-300">
            Lecteur Vitale : {{ apilec.reader }}
          </div>
          <div class="text-gray-300">
            Mode d'accès : {{ AccessModes[apilec.accessMode] }}
          </div>
          <div class="text-gray-300">
            Version Apilec : {{ apilec.version }}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  </div>
</template>
